import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';

const DisclaimersList = styled<any, any>('ol')`
    ${propStyles};
`;

DisclaimersList.defaultProps = {
    fontSize: 'xs',
    fontFamily: 'body',
    fontWeight: 'normal',
    lineHeight: '1.4',
    color: 'body',
    listStyle: 'none',
};

const DisclaimerListItem = styled<any, any>('li')`
    ${propStyles};
`;

DisclaimerListItem.defaultProps = {
    display: 'flex',
    marginY: 'sm',
};

const DisclaimerCharacter = styled<any, any>('div')`
    ${propStyles};
    flex-shrink: 0;
`;

DisclaimerCharacter.defaultProps = {
    margin: '0 0.5em 0 0',
};

const DisclaimerContent = styled<any, any>('div')`
    ${propStyles};
`;

DisclaimerContent.defaultProps = {};

interface DisclaimersProps {
    theme?: { [property: string]: string | number };
    marginX?: string | number;
    disclaimers: Array<DisclaimerObject | string>;
}

interface DisclaimerObject {
    character?: string;
    content: string;
}

export const Disclaimers: React.SFC<DisclaimersProps> = ({
    theme,
    disclaimers = [],
    ...props
}) =>
    disclaimers.length > 0 ? (
        <DisclaimersList {...theme.DisclaimersList} {...props}>
            {disclaimers.map((disclaimer, index) => (
                <DisclaimerListItem key={index} {...theme.DisclaimerListItem}>
                    {(disclaimer as DisclaimerObject).character && (
                        <DisclaimerCharacter {...theme.DisclaimerCharacter}>
                            {(disclaimer as DisclaimerObject).character}
                        </DisclaimerCharacter>
                    )}
                    <DisclaimerContent
                        dangerouslySetInnerHTML={{
                            __html:
                                (disclaimer as DisclaimerObject).content ||
                                disclaimer,
                        }}
                        {...theme.DisclaimerContent}
                    />
                </DisclaimerListItem>
            ))}
        </DisclaimersList>
    ) : null;

export default withTheme(observer(Disclaimers));



// WEBPACK FOOTER //
// ./src/Components/Disclaimers.tsx